module.exports = __webpack_public_path__ + "img/icons BFr_30.eec4d25e.png";